export default theme => {

    const isDark = theme.palette.mode === 'dark'

    return {

        root: {
            position: 'static',
            width: 280,
            transform: 'none'
        },

        alert: {
            alignItems: 'center',
            background: 'rgba(200, 230, 201, 0.32)',
            borderRadius: 6,
            boxSizing: 'border-box',
            color: isDark ? 'rgba(255, 255, 255, 0.90)' : 'rgba(0, 0, 0, 0.70)',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 500,
            letterSpacing: '0.15px',
            lineHeight: '24px',
            minHeight: 56,
            padding: '8px 16px',
            width: 280,

            '& .MuiAlert-message': {
                color: isDark ? 'rgba(255, 255, 255, 0.90)' : 'rgba(0, 0, 0, 0.70)',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: 500,
                letterSpacing: '0.15px',
                lineHeight: '24px',
                padding: 0
            },

            '& .MuiAlert-icon': {
                alignItems: 'center',
                color: isDark ? 'rgba(255, 255, 255, 0.90)' : 'rgba(0, 0, 0, 0.70)',
                display: 'flex',
                marginRight: 12,
                padding: 0
            },

            '& .MuiAlert-action': {
                marginLeft: 12,
                padding: 0
            },

            '& .MuiAlert-action .MuiIconButton-root': {
                color: isDark ? 'rgba(255, 255, 255, 0.90)' : 'rgba(0, 0, 0, 0.70)',
                padding: 0
            },

            '& .MuiAlert-action .MuiSvgIcon-root': {
                fontSize: 22,
                height: 22,
                width: 22
            },

            [theme.breakpoints.down('sm')]: {
                maxWidth: 'calc(100vw - 32px)',
                minHeight: 56,
                width: 'calc(100vw - 32px)'
            }
        },

        successIcon: {
            color: theme?.palette?.success?.main || '#2E7D32',
            fontSize: 22,
            height: 22,
            width: 22
        }
    }
}